<template>
  <div id="hres75u">
    <hrms-search-box-table v-show="indexDisp"
            :data="index"
            :nowLang="dash.nowLang"
            :columns="columns[dash.nowLang].index"
            :receivedStore="receivedHres75uIndex"
            searchBoxAlias="approve"
            :detailEvent="detailEvent"
            :approveEvent="approveEvent"
            :approveRowBool="true" />

    <detail v-show="detailDisp"
            :labels="labels[dash.nowLang]"
            :labelsButton="dash.button[dash.nowLang]"
            :detail="detail"
            :tab2Table="columns[dash.nowLang].detailTab2"
            :toggle="toggle"
            :nowLang="dash.nowLang" />

    <div class="form-group-button" v-show="false">
      <button class="btn bg-blue" data-toggle="modal" ref="approve" data-target="#hres75u-popup-approve"><i class="fa fa-list-alt"></i> {{ btn_approve }}</button>
    </div>

    <popup-approve :labels="labels[dash.nowLang]"
            :labelsButton="dash.button[dash.nowLang]"
            :nowLang="dash.nowLang"
            :indexSelected="indexSelected"
            :postHres75uSendApprove="postHres75uSendApprove"
            :codappr="codempid"
            :descCodappr="dash.currentUser.username[dash.nowLang]"
            :detailSubmit="detailSubmit"
            :receivedHres75uDetailSubmit="receivedHres75uDetailSubmit"/>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/hres75u/mutation-types'
import detail from 'components/hres75u/detail'
import popupApprove from 'components/hres75u/popupApprove'
import moment from 'moment'
import swal from 'sweetalert'

export default {
  name: 'hres75u',
  data () {
    return {
      dash: this.$parent.$parent.$parent,
      dtereq: moment().format('DD/MM/YYYY'),
      btn_approve: 'Approve'
    }
  },
  created () {
    this.receivedHres75uColumnsLabels()
    this.receivedHres75uIndex()
  },
  computed: {
    codempid () {
      let currentUser = this.dash.currentUser
      return currentUser.p_codempid
    },
    ...mapGetters({
      indexDisp: types.GET_HRES75U_INDEX_DISP,
      detailDisp: types.GET_HRES75U_DETAIL_DISP,
      columns: types.GET_HRES75U_COLUMNS,
      labels: types.GET_HRES75U_LABELS,
      index: types.GET_HRES75U_INDEX,
      indexSelected: types.GET_HRES75U_INDEX_SELECTED,
      detail: types.GET_HRES75U_DETAIL,
      detailSubmit: types.GET_HRES75U_DETAIL_SUBMIT
    })
  },
  methods: {
    pageDetail (event) {
      let detailParams = this.indexSelected
      this.receivedHres75uDetail(detailParams)
      this.toggle('detail')
    },
    detailEvent (param) {
      this.setIndexSelected(param)
      this.pageDetail()
    },
    approveEvent (dataRows) {
      let dataRowsFiltered = dataRows.filter(function (dataRow) {
        return dataRow.flgStaappr !== 'undefined' && dataRow.flgStaappr !== 'P' && dataRow.flgStaappr.trim() !== ''
      })
      if (dataRowsFiltered.length > 0) {
        this.setIndexSelected(dataRowsFiltered[0])
        this.receivedHres75uDetailSubmit(this.indexSelected)
        this.$refs.approve.click()
      } else {
        swal({
          title: 'ยืนยันการทำรายการ',
          text: 'รายการยังไม่ถูกเลือก'
        })
      }
    },
    ...mapMutations({
      setIndexSelected: types.SET_HRES75U_INDEX_SELECTED
    }),
    ...mapActions({
      toggle: types.TOGGLE_HRES75U_PAGE,
      receivedHres75uColumnsLabels: types.RECEIVED_HRES75U_COLUMNS_LABELS,
      receivedHres75uIndex: types.RECEIVED_HRES75U_INDEX,
      receivedHres75uDetail: types.RECEIVED_HRES75U_DETAIL,
      receivedHres75uDetailSubmit: types.RECEIVED_HRES75U_DETAIL_SUBMIT,
      postHres75uSendApprove: types.POST_HRES75U_SEND_APPROVE
    })
  },
  components: {
    detail,
    popupApprove
  }
}
</script>




// WEBPACK FOOTER //
// component.vue?63274730